function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileuploadinverted = function SvgFileuploadinverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "13 13 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13h-7c-.98.014-1.763.82-1.75 1.8v14.4c-.013.98.77 1.786 1.75 1.8h10.5A1.776 1.776 0 0 0 29 29.2V18.4L23.75 13Zm-.437 12.6v2.7h-2.626v-2.7H18.5L22 22l3.5 3.6h-2.188.001Zm-.438-6.3v-4.95l4.813 4.95h-4.813Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgFileuploadinverted;